import React from 'react'
import AnimateImageThree from './AnimateImageThree'
import AnimateTitleThree from './AnimatedTitleThree'

const Designing = () => {
    return (
        <section className='section-designing section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-8 offset-md-2'>
                    <div className='section-img-heading'>
                        <div className='section-title'>
                        <AnimateTitleThree/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageThree/>
                    </div>
                    </div>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>The design stage is where creativity begins to take form. Our designers translate ideas into detailed sketches and hand-drawn artworks that define the embroidery layout, motifs, and design. Once reviewed and approved by the client or Ms. Parul, these concepts evolve into intricate embroidery artworks — meticulously developed either digitally or by hand. Each design becomes a canvas of innovation, blending artisanal craftsmanship with contemporary refinement.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default Designing